<template>

<div class="rn-gallery-area gallery-area rn-section-gap bg_color--1">
  <NuxtLink :to="'/gallery'" >
  <v-container>
    
    <v-row v-if="isModerno" class="row-gap-30 mt--10">
        <v-col
          :cols="comNumColumnas"
          v-for="(archivo, index) in compArchivos"
          :key="archivo.id || index"
          class="d-flex py-4"
        >
          <div
            class="modern-gallery-card d-flex flex-column fill-height w-100"
            @click.prevent="openLightbox(Number(index))"
          >
            <!-- Image Container with zoom effect and overlay -->
            <div class="modern-image-container relative overflow-hidden">
              <v-img
                v-if="archivo.id && archivo.showInGallery"
                :src="imagenIDtoSRC(archivo.id)"
                aspect-ratio="1"
                class="modern-gallery-image"
                cover
                :alt="'Imagen ' + (index + 1) + ' - ' + NOTARIA.Nombre + ' - Galería'"
              />
              <!-- Hover overlay with a zoom icon -->
              <div class="modern-gallery-overlay d-flex align-center justify-center">
                <div class="zoom-icon-wrapper d-flex align-center justify-center">
                  <v-icon large color="primary">mdi-magnify-plus-outline</v-icon>
                </div>
              </div>
            </div>

            <!-- Description block outside image with clean borders, if enabled -->
            <div
              v-if="NOTARIA?.Theme.Gallery.ShowDescriptions && archivo.Description"
              class="modern-gallery-content pa-5 d-flex flex-column flex-grow-1"
            >
              <p
                class="modern-gallery-description flex-grow-1 mb-0"
                v-html="archivo.Description.replace(/(?:\r\n|\r|\n)/g, '<br>')"
              ></p>
            </div>
          </div>
        </v-col>
    </v-row>

    <v-row v-else class="mt--30">
        <!-- Start Single Gallery Area  -->
        <v-col
          :cols=comNumColumnas
          v-for="(archivo, index) in compArchivos"
          :key="archivo.id"
          class="py-4"
        >
          <div class="gallery-static card-gallery-notin">
            <div class="thumbnail" v-if="archivo.id && archivo.showInGallery" style="cursor: pointer;" @click.prevent="openLightbox(Number(index))">
              <img :src="imagenIDtoSRC(archivo.id)"/>
                <div class="mt-4" v-if="NOTARIA?.Theme.Gallery.ShowDescriptions && archivo.Description">
                    <p class="gallery-description" v-html="archivo.Description.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                </div>   
            </div>   
               
          </div>
        </v-col>
        <!-- End Single Gallery Area  -->
    </v-row>
  </v-container>
  </NuxtLink>
  <GalleryLightbox v-model="lightboxDialog" :images="lightboxImages" :initialIndex="lightboxIndex" />
</div>
</template>
<script setup lang="ts">  

import { useStore } from '../../store/index'
const store = useStore()
const { NOTARIA, ARCHIVOS_COMUNES } = storeToRefs(store)

import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()

const lightboxDialog = ref(false)
const lightboxIndex = ref(0)
const lightboxImages = computed(() => {
  return compArchivos.value.map((a: any) => ({ src: imagenIDtoSRC(a.id) }))
})

const openLightbox = (index: number) => {
  lightboxIndex.value = index
  lightboxDialog.value = true
}

const compArchivos = computed(() => {
  const source = (ARCHIVOS_COMUNES.value && ARCHIVOS_COMUNES.value.length > 0)
    ? ARCHIVOS_COMUNES.value
    : (NOTARIA.value?.Archivos || []);
  let filtered = source.filter((a: any) => a.showInGallery) || [];
  return filtered.sort((a: any, b: any) => (Number(a.Orden) || 9999) - (Number(b.Orden) || 9999));
})
const comNumColumnas = computed(()=>{
        if(NOTARIA.value?.Theme.Gallery.NumeroColumnas == 1)
        {
          return 12
        }else if(NOTARIA.value?.Theme.Gallery.NumeroColumnas == 2)
        {
          return 6
        }else if(NOTARIA.value?.Theme.Gallery.NumeroColumnas == 3)
        {
          return 4
        }else if(NOTARIA.value?.Theme.Gallery.NumeroColumnas == 4)
        {
          return 3
        }
      })

const isModerno = computed(() => {
  return NOTARIA.value?.Theme?.Gallery?.Tipo === 'moderno';
})

import { useStyles } from '../../store/styles';
const style = useStyles();
const descriptionColor = style.ThemeSectionGallery.Color
const descriptionShadow = style.ThemeSectionGallery.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionGallery.BackgroundColor:""
const descriptionFont = style.ThemeSectionGallery.Font
const descriptionSize = style.ThemeSectionGallery.Size
const descriptionWeight = style.ThemeSectionGallery.Weight
const descriptionAlign = style.ThemeSectionGallery.Align
</script>
<style lang="scss">
  .gallery-description{
    color:v-bind(descriptionColor) !important;
    text-shadow:v-bind(descriptionShadow)  !important;
    font-size:v-bind(descriptionSize) !important;
    font-family: v-bind(descriptionFont) !important;
    font-weight:v-bind(descriptionWeight) !important;
    text-align:v-bind(descriptionAlign)  !important;
  }

  /* Modern Gallery Premium Styles */
  .modern-gallery-card {
    position: relative;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    cursor: pointer;
    z-index: 1;

    .modern-image-container {
      position: relative;
      width: 100%;
      overflow: hidden;
      border-radius: 20px 20px 0 0;
      
      &:last-child {
        border-radius: 20px;
      }

      .modern-gallery-image {
        transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1) !important;
        width: 100%;
      }

      .modern-gallery-overlay {
        position: absolute;
        inset: 0;
        background: rgba(57, 73, 171, 0.35);
        opacity: 0;
        backdrop-filter: blur(4px);
        transition: all 0.4s ease;
        z-index: 2;

        .zoom-icon-wrapper {
          width: 56px;
          height: 56px;
          background: rgba(255, 255, 255, 0.25);
          border: 1px solid rgba(255, 255, 255, 0.4);
          border-radius: 50%;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          transform: scale(0.8);
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
      }
    }

    .modern-gallery-content {
      background: #ffffff;
      border-top: 1px solid rgba(0, 0, 0, 0.03);
      
      .modern-gallery-description {
        color: v-bind(descriptionColor) !important;
        text-shadow: v-bind(descriptionShadow) !important;
        font-size: v-bind(descriptionSize) !important;
        font-family: v-bind(descriptionFont) !important;
        font-weight: v-bind(descriptionWeight) !important;
        text-align: v-bind(descriptionAlign) !important;
        line-height: 1.5;
      }
    }

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
      border-color: rgba(0, 0, 0, 0.1);

      .modern-gallery-image {
        transform: scale(1.08) !important;
      }

      .modern-gallery-overlay {
        opacity: 1;

        .zoom-icon-wrapper {
          transform: scale(1);
          background: rgba(255, 255, 255, 0.9);
          color: #3949ab !important;
          
          ::v-deep .v-icon {
            color: #3949ab !important;
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    .modern-gallery-card {
      border-radius: 16px;
      
      .modern-image-container {
        border-radius: 16px 16px 0 0;
        
        &:last-child {
          border-radius: 16px;
        }
      }
    }
  }
</style>